document.documentElement.classList.remove('no-js');

const header = document.querySelector('[data-crepulo-header]');
const menu = document.querySelector('[data-mobile-menu]');
const openMenu = document.querySelector('[data-open-menu]');
const closeMenu = document.querySelector('[data-close-menu]');

if (header) {
  const setHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
  setHeader();
  window.addEventListener('scroll', setHeader, { passive: true });
}

if (menu && openMenu && closeMenu) {
  openMenu.addEventListener('click', () => {
    menu.classList.add('is-open');
    openMenu.setAttribute('aria-expanded', 'true');
  });

  closeMenu.addEventListener('click', () => {
    menu.classList.remove('is-open');
    openMenu.setAttribute('aria-expanded', 'false');
  });
}

document.querySelectorAll('[data-product-section]').forEach((productSection) => {
  const variantSelect = productSection.querySelector('.variant-select');
  const primaryImage = productSection.querySelector('[data-pdp-primary-image]');

  if (!variantSelect || !primaryImage) return;

  const showSelectedVariantImage = () => {
    const selectedOption = variantSelect.options[variantSelect.selectedIndex];
    const mediaUrl = selectedOption?.dataset.mediaUrl;

    if (!mediaUrl) return;

    primaryImage.src = mediaUrl;
    primaryImage.removeAttribute('srcset');
    primaryImage.alt = selectedOption.dataset.mediaAlt || selectedOption.textContent.trim();
  };

  variantSelect.addEventListener('change', showSelectedVariantImage);
  showSelectedVariantImage();
});
